import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Layout from "../../components/layout/Layout";
import { CheckItems } from "../../redux/action/checklists";
import moment from "moment";
import { useParams } from "react-router-dom";
import { APIURL } from "../../redux/action/config";

const ViewCheckLists = () => {
  const { id } = useParams();
  const [details, setDetails] = useState("");
  const [allitems, setAllItems] = useState("");
  const [staffDetails, setStaffDetails] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(`${APIURL}/api/v1/checklist/staff-checklist/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => setDetails(result?.data?.checklist))
      .catch((error) => console.log("error", error))
      .finally(() => setLoading(false));

    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/checklistitem`, requestOptions)
      .then((response) => response.json())
      .then((result) => setAllItems(result?.data?.checklistchild))
      .catch((error) => console.log("error", error));

    // Staff Data
    const token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/users/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setStaffDetails(result?.data?.user);
      })
      .catch((error) => console.log("error", error));
  }, []);

  //checkIn Staff
  const data = details?.checkIn;
  const managedChecklist =
    data &&
    data?.reduce((acc, item) => {
      const existingParent = acc.find(
        (parent) => parent.name === item.parentName
      );
      if (existingParent) {
        existingParent.children.push(item);
      } else {
        acc.push({
          name: item.parentName,
          children: [item],
        });
      }
      return acc;
    }, []);

  //checkout staff
  const item = details?.checkOut;
  const managedCheckOutlist =
    item &&
    item?.reduce((acc, item) => {
      const existingParent = acc.find(
        (parent) => parent.name === item.parentName
      );
      if (existingParent) {
        existingParent.children.push(item);
      } else {
        acc.push({
          name: item.parentName,
          children: [item],
        });
      }
      return acc;
    }, []);

  return (
    <Layout title="View Checklists" page="checklists">
      {details?._id ? (
        <div id="kt_content_container" className="container-fluid">
          <div className="row  g-xxl-10">
            <div className="col-md-6">
              <div className="staff-conent d-flex mb-2">
                <div className="staff-name">
                  <label className="fw-bolder">Staff Name : </label>
                </div>
                <div className="staff-data">
                  <span className="mx-2">
                    {details?.staffId?.firstName
                      ? details?.staffId?.firstName
                      : `${staffDetails?.firstName} ${
                          staffDetails?.middleName
                            ? staffDetails?.middleName
                            : ""
                        } ${
                          staffDetails?.lastName ? staffDetails?.lastName : ""
                        }`}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="staff-conent d-flex mb-2">
                <div className="staff-date">
                  <label className="fw-bolder">Date :</label>
                </div>
                <div className="staff-data-date">
                  <span className="mx-2">
                    {moment(details?.staffId?.createdAt)
                      .utc()
                      .format("DD-MM-YYYY")}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-5 g-xxl-10 mt-0">
            <div className="col-md-6">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <h2 style={{ fontWeight: "500" }}>Sign In Checklist</h2>
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                    >
                      {managedChecklist &&
                        managedChecklist?.map((item) => {
                          return (
                            <>
                              <thead>
                                <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                                  <th style={{ width: "155px" }}>
                                    {item?.name}
                                  </th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {item?.children &&
                                  item?.children?.map((item) => {
                                    return (
                                      <tr className="pro-list-info">
                                        <td>
                                          <div className="form-check form-check-sm">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={
                                                item?.isChecked == true
                                                  ? true
                                                  : false
                                              }
                                              disabled
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          {item?.name ? item?.name : "N/A"}
                                        </td>
                                        <td>
                                          {item?.itemMessage
                                            ? item?.itemMessage
                                            : "N/A"}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </>
                          );
                        })}
                    </table>
                  </div>
                </div>
              </div>
              <div className="staff-conent d-flex mb-2">
                <div className="staff-name">
                  <label className="fw-bolder">Check-in Remarks : </label>
                </div>
                <div className="staff-data">
                  <span className="mx-2">
                    {details?.checkInMessage ? details?.checkInMessage : "N/A"}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <h2 style={{ fontWeight: "500" }}>Sign Out Checklist</h2>
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                    >
                      {managedCheckOutlist &&
                        managedCheckOutlist?.map((item) => {
                          return (
                            <>
                              <thead>
                                <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                                  <th style={{ width: "155px" }}>
                                    {item?.name}
                                  </th>
                                  <th></th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {item?.children &&
                                  item?.children?.map((item) => {
                                    return (
                                      <tr className="pro-list-info">
                                        <td>
                                          <div className="form-check form-check-sm">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={
                                                item?.isChecked == true
                                                  ? true
                                                  : false
                                              }
                                              disabled
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          {item?.name ? item?.name : "N/A"}
                                        </td>
                                        <td>
                                          {item?.itemMessage
                                            ? item?.itemMessage
                                            : "N/A"}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </>
                          );
                        })}
                    </table>
                  </div>
                </div>
              </div>
              <div className="staff-conent d-flex mb-5">
                <div className="staff-name">
                  <label className="fw-bolder">Check-out Remarks : </label>
                </div>
                <div className="staff-data">
                  <span className="mx-2">
                    {details?.checkOutMessage
                      ? details?.checkOutMessage
                      : "N/A"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : loading ? (
        <div className="spinner-outer p-5">
          <div className="spinner-border w-80" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <p style={{ margin: "14px 22px" }}>No Data Found</p>
      )}
    </Layout>
  );
};

export default connect(null, { CheckItems })(ViewCheckLists);
